import React, { Component } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from "jquery";
import cookie from "js-cookie";

import i18next from "i18next";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import "./UsageList.css";

import 'antd/dist/antd.css';
import {Table,Breadcrumb,Spin} from 'antd'
import { ArrowRightOutlined,ArrowLeftOutlined} from '@ant-design/icons';

import {itemRender,onShowSizeChange} from "../../paginationfunction"
import "../../antdstyle.css"

import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import { connect } from "react-redux";


import API from "../../../utils/API";


class UsageList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
      category_en: "",
      category_ar: "",
      isLoading: false,
      startDate: new Date(),
      agents: [],
      filterLocation: [],
      loc_tap: "nav-link active",
      day_tap: "nav-link",
      selected_item: 1,
      selectedLocations: [],
      selectedUsers: [],
    };
  }

  componentDidMount() {
    this.setState({ isLoading: true });

    this.fetchData();
  }

  fetchData = () => {
    const { lang } = this.props;

    this.setState({ isLoading: true });
    const token = cookie.get("token");
    API
      .get("/users")
      .then((response) => {
        this.setState({
          agents:
            lang == "en" ? response.data.agents_en : response.data.agents_ar,
        });
      })

      .catch((e) => console.log("error"));

    API
      .get("/filterLocation")
      .then((response) => {
        this.setState({
          filterLocation:
            lang == "en"
              ? response.data.locations_en
              : response.data.locations_ar,
        });
      })

      .catch((e) => console.log("error"));

    API
      .get( "/agencypackegedetailswithusage")
      .then((response) => {

        this.setState({ isLoading: false, locations: response.data.locations });
     
      })
      .catch((e) => console.log("error"));
  };

  fetchLocationsbyuser = (newValue) => {
    const data = { users: newValue, locations: this.state.selectedLocations };
    const token = cookie.get("token");
    this.setState({ isLoading: true });
    API
      .post("/filterusagepackage", data)
      .then((response) => {
        console.log("server response", response.data);
        this.setState({ locations: response.data.locations, isLoading: false });
      })

      .catch((e) => (e) => console.log("error"));
  };
  // select by location name
  fetchLocationsbylocation = (newValue) => {
    const data = { users: this.state.selectedUsers, locations: newValue };
    const token = cookie.get("token");
    this.setState({ isLoading: true });
    API
      .post("/filterusagepackage", data)
      .then((response) => {
        console.log("server response", response.data);
        this.setState({ locations: response.data.locations, isLoading: false });
      })

      .catch((e) => (e) => console.log("error"));
  };

  selectLocation = (e) => {
    this.setState({
      loc_tap: "nav-link active",
      day_tap: "nav-link",
      selected_item: 1,
    });
  };

  selectDay = (e) => {
    this.setState({
      loc_tap: "nav-link",
      day_tap: "nav-link active",
      selected_item: 2,
    });
  };

  render() {
    const { lang } = this.props;

    const columns = [  
            
      {
          title: <> {lang == "en" ? "Location" : "الموقع"}</> ,
          render:(text,record)=>(
              <>
            {lang == "en" ? record.area_en : record.area_ar}
            </>
          )
        },

       // 


        {
            title: <> {lang == "en" ? "For Rent" : "للايجار"}</> ,
            render:(text,record)=>(
                <>   {record["rent"].length > 0
                ? record["rent"].map(
                    (rent) => rent.rent_count
                  )
                : 0}
              
              </>
            )
          
    
        },
          {
              title: <> {lang == "en" ? "For Sale" : "للبيع"}</>  ,
              render:(text,record)=>(
                  <>
               {record["buy"].length > 0
                                        ? record["buy"].map((buy) => buy.buy_count)
                                        : 0}
                </>
              )
    
          },
          {
            title: <> {lang == "en" ? "Basic" : "عادي"}</> ,
            render:(text,record)=>(
              <>
             {record["basic"].length > 0
              ? record["basic"].map(
               (basic) => basic.basic_count
                )
               : 0}
            </>
          )
          },
          {
            title: <> {lang == "en" ? "Featured" : "مميز"}</> ,
            render:(text,record)=>(
                <>
                  {record["featured"].length > 0
                                        ? record["featured"].map(
                                            (featured) =>
                                              featured.featured_count
                                          )
                                        : 0}
                </>
            )
           // dataIndex: 'beds',
          //  sorter: (a, b) => a.beds.length - b.beds.length,
          },
          {
            title: <> {lang == "en" ? "Premium" : "غالي"}</> ,
            render:(text,record)=>(
              <>
                 {record["premium"].length > 0
                  ? record["premium"].map(
                 (premium) => premium.premium_count
               )
              : 0}
              </>
          )
          },
        {
          title: <> {lang == "en" ? "Total" : "المجموع"}</>,
          render: (text, record) => (
            record.property_count
        
            ),
        },
    
 
    ]

    return (
      <div>
        <div className="container-fluid">
          <div className=" page-titles">
          <Breadcrumb
          style={{
            margin: '16px 0',
          }}
        >
          <Breadcrumb.Item>
          {lang=="en"?<ArrowRightOutlined />:<ArrowLeftOutlined />}
          </Breadcrumb.Item>
          <Breadcrumb.Item><> {lang == "en" ? "Quota Usage" : " الحزمة المستخدمة"}</></Breadcrumb.Item>
          
        </Breadcrumb>

         
            <div className="row" style={{ marginTop: "20px" }}>
              <div className="col-md-3">
                <label>{lang == "en" ? "Users" : "المستخدمين"} </label>
                <div dir="rtl" style={{ textAlign: "right" }}>
                <Autocomplete
                dir="rtl"
                  multiple
                  options={this.state.agents}
                  onChange={(event, newValue) => {
                    this.setState({ selectedUsers: newValue });
                    this.fetchLocationsbyuser(newValue);
                  }}
                  getOptionLabel={(option) => option.name}
                  // defaultValue={[top100Films[13],]}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label=""
                      placeholder=""
                    />
                  )}
                />
                </div>
              </div>
              <div className="col-md-6"></div>
              <div className="col-md-3">
                <label>{lang == "en" ? "Location" : "الموقع"} </label>
                <Autocomplete
                  multiple
                  options={this.state.filterLocation}
                  defaultValue={this.state.selectedLocations}
                  onChange={(event, newValue) => {
                    this.setState({ selectedLocations: newValue });
                    this.fetchLocationsbylocation(newValue);
                    //  const agentData= {selectedLanguage: this.selectedLanguage, selectedNationality: this.state.selectedNationality, selectedLocation: newValue, selectedArea: this.state.selectedArea}
                    // this.fetchLocations(newValue)
                    //console.log("selected Loca", this.state.locationValue)
                  }}
                  getOptionLabel={(option) => option.location}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label=""
                      placeholder=""
                    />
                  )}
                />
              </div>
            </div>
          </div>

          <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist"></ul>

                                   <Table className="table-striped"
                                    loading={this.state.isLoading}
                                    pagination={{
                                      pageSizeOptions: ["5", "10", "20", "50", "100"],
                                      total: this.state?.locations?.total > 0 && this.state.locations.total,
                                      pageSize: this.state.locations.per_page,
                                      current: this.state.locations.current_page,
                                      showTotal: (total, range) =>
                                      lang === "en"
                                          ? `Showing ${range[0]} to ${range[1]} of ${total} entries`
                                          : `عرض ${range[0]} إلى ${range[1]} من إجمالي ${total} إدخالاً`, // Arabic
                                      showSizeChanger: true,
                                      onShowSizeChange: onShowSizeChange,
                                      locale: {
                                        items_per_page: lang === "en" ? "/page" : "/صفحة", // Dynamic language for the `/page` text
                                      },
                                      itemRender: (current, type, originalElement) => {
                                        if (type === "prev") {
                                          return lang === "en" ? <a>Previous</a> : <a>السابق</a>; // Arabic
                                        }
                                        if (type === "next") {
                                          return lang === "en" ? <a>Next</a> : <a>التالي</a>; // Arabic
                                        }
                                        
                                        return originalElement;
                                      },
                                    }}
                                    style = {{overflowX : 'auto'}}
                                    columns={columns}                 
                                    // bordered
                                    dataSource={this.state?.locations}
                                    rowKey={record => record}
                                    />

     
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.auth.lang, 
});
export default connect(mapStateToProps)(UsageList);
